<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-07-20 15:40:57
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-07-21 14:58:05
-->
<template>
	<div>
		<el-dialog title="提示" :visible.sync="dialogVisible" width="426px" :before-close="handleClose">
			<h5 class="fz-14">
				<i class="el-icon-warning mr-4 yx-color-orange-2"></i>
				<span>是否确认撤销分配？</span>
			</h5>
			<div class="ml-16">撤销后，系统将取消当次分配操作，且任务变更为“处理失败”。</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="showFailedDialog">确认撤销</el-button>
			</span>
		</el-dialog>
		<failed-dialog :operator="operator" :taskId="taskId" ref="failedDialog"></failed-dialog>
	</div>
</template>

<script>
import FailedDialog from '../failedDialog';
import { confirmCancle } from '@/api/talentCRM';
export default {
	data() {
		return {
			dialogVisible: false,
		};
	},
	props: {
		operator: {
			type: String,
			default: () => '',
		},
		taskId: {
			type: String,
			default: () => '',
		},
	},
	components: {
		FailedDialog,
	},
	methods: {
		show() {
			this.dialogVisible = true;
		},
		handleClose(done) {
			done();
		},
		async showFailedDialog() {
			this.dialogVisible = false;
			await confirmCancle({ common_task_id: this.taskId });
			this.$message.success('撤销成功');
		},
	},
};
</script>
